<div class="create-edit-shipment-container">
  <div class="create-edit-shipment-wrapper p-2">
    <div class="header d-flex align-items-center py-2">
      <span class="secondary-details mr-2" *ngIf="specHeader === 'Create Shipment Specification'">
        {{
          'mapping.specifications.shipmentSpecificationList.addEditShipmentSpecification.createShipmentSpecification'
            | translate
        }}
      </span>

      <span class="secondary-details mr-2" *ngIf="specHeader === 'Update Shipment Specification'">
        {{
          'mapping.specifications.shipmentSpecificationList.addEditShipmentSpecification.updateShipmentSpecification'
            | translate
        }}
      </span>

      <small class="text-danger text-right">{{
        'mapping.specifications.shipmentSpecificationList.addEditShipmentSpecification.allIndicatedFieldsMandatory'
          | translate
      }}</small>
    </div>
    <div class="create-edit-form row">
      <div class="col-md-6">
        <form class="row" [formGroup]="shipmentMappingForm">
          <div>
            <div class="row mt-2">
              <div class="col-md-2">
                <label class="required-field">
                  {{
                    'mapping.specifications.shipmentSpecificationList.addEditShipmentSpecification.specificationName'
                      | translate
                  }}</label
                >
              </div>
              <div class="col-md-5">
                <input
                  class="form-control"
                  maxlength="52"
                  size="52"
                  formControlName="specifications_id" />
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-md-2">
                <label class="control-label required-field">
                  {{
                    'mapping.specifications.shipmentSpecificationList.addEditShipmentSpecification.formatType'
                      | translate
                  }}</label
                >
              </div>
              <div class="col-md-3">
                <mat-radio-group aria-label="Select an option" formControlName="file_format">
                  <mat-radio-button class="mr-2" value="EASYSHIP" (click)="easyship()">
                    {{
                      'mapping.specifications.shipmentSpecificationList.addEditShipmentSpecification.easyShip'
                        | translate
                    }}</mat-radio-button
                  >
                  <mat-radio-button value="STANDARD" (click)="standard()">
                    {{
                      'mapping.specifications.shipmentSpecificationList.addEditShipmentSpecification.standard'
                        | translate
                    }}
                  </mat-radio-button>
                </mat-radio-group>
              </div>
              <div class="col-md-2">
                <label class="required-field">
                  {{
                    'mapping.specifications.shipmentSpecificationList.addEditShipmentSpecification.delimiter'
                      | translate
                  }}
                </label>
              </div>
              <div class="col-md-1">
                <input class="input" maxlength="1" size="1" formControlName="delimiter" />
              </div>
            </div>
            <div class="row mt-2"></div>
            <div class="row">
              <div class="col-md-2">
                <label class="control-label">
                  {{
                    'mapping.specifications.shipmentSpecificationList.addEditShipmentSpecification.abortDuringErrors'
                      | translate
                  }}</label
                >
              </div>
              <div class="col-md-5">
                <mat-checkbox formControlName="abortOnErrors"></mat-checkbox>
              </div>
            </div>

            <div class="row">
              <div class="col-md-2">
                <label class="control-label">{{
                  'mapping.specifications.shipmentSpecificationList.addEditShipmentSpecification.headers'
                    | translate
                }}</label>
              </div>
              <div class="col-md-5">
                <mat-checkbox formControlName="headers"></mat-checkbox>
              </div>
            </div>

            <div class="row">
              <div class="col-md-2">
                <label class="control-label">
                  {{
                    'mapping.specifications.shipmentSpecificationList.addEditShipmentSpecification.automatedUpload'
                      | translate
                  }}</label
                >
              </div>
              <div class="col-md-5">
                <mat-checkbox formControlName="use_for_automated_upload">
                  {{
                    'mapping.specifications.shipmentSpecificationList.addEditShipmentSpecification.useForAutomaticUpload'
                      | translate
                  }}</mat-checkbox
                >
              </div>
            </div>
            <div class="row">
              <div class="col-md-2">
                <label class="control-label required-field">
                  {{
                    'mapping.specifications.shipmentSpecificationList.addEditShipmentSpecification.shipperAddress'
                      | translate
                  }}</label
                >
              </div>
              <div class="col-md-3 w-40">
                <mat-checkbox (change)="isCheckedUseFromFile($event)" formControlName="useFromFile">
                  {{
                    'mapping.specifications.shipmentSpecificationList.addEditShipmentSpecification.useFromFile'
                      | translate
                  }}
                </mat-checkbox>
                <br />
                <div *ngIf="!isUseFromFile">
                  <label>
                    {{
                      'mapping.specifications.shipmentSpecificationList.addEditShipmentSpecification.useShipperAddressFile'
                        | translate
                    }}</label
                  >
                  <mat-select
                    class="form-control"
                    placeholder="Select Shipper"
                    (selectionChange)="changeAddressValue($event)"
                    formControlName="use_shipper_id">
                    <mat-option [value]="">
                      {{
                        'mapping.specifications.shipmentSpecificationList.addEditShipmentSpecification.selectShipper'
                          | translate
                      }}
                    </mat-option>
                    <mat-option
                      *ngFor="let address of shipperAddressData"
                      [value]="address.address_id">
                      {{ address.shipperNickName }}
                    </mat-option>
                  </mat-select>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="col-md-6">
        <div class="row mt-2 mb-2" cdkDropListGroup>
          <div class="col-md-5">
            <h5 class="ml-2">
              {{
                'mapping.specifications.shipmentSpecificationList.addEditShipmentSpecification.availableColumns'
                  | translate
              }}
            </h5>
            <div class="example-container">
              <div
                style="height: 100vh; overflow-y: auto"
                cdkDropList
                id="cdk1"
                [cdkDropListData]="unMappedFields"
                class="example-list"
                (cdkDropListDropped)="drop($event)">
                <div class="example-box" *ngFor="let item of unMappedFields" cdkDrag>
                  {{ item }}
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-5">
            <h5 class="ml-2">
              {{
                'mapping.specifications.shipmentSpecificationList.addEditShipmentSpecification.csvFileColumns'
                  | translate
              }}
            </h5>
            <div class="example-container">
              <div
                style="height: 100vh; overflow-y: auto"
                cdkDropList
                id="cdk2"
                [cdkDropListData]="mappedFields"
                class="example-list"
                (cdkDropListDropped)="drop($event)">
                <div
                  class="example-box"
                  *ngFor="let item of mappedFields"
                  [ngClass]="{ 'required-field': isFieldMondatory(item) }"
                  cdkDrag>
                  {{ item }}

                  <div
                    *ngIf="item === 'lineItems'"
                    class="pointer"
                    [matTooltip]="lineItemLists"
                    #tooltip="matTooltip"
                    mat-raised-button>
                    <i class="bi bi-info-circle"></i>
                  </div>

                  <div
                    *ngIf="item === 'pieces'"
                    class="pointer"
                    [matTooltip]="pieceslists"
                    #tooltip="matTooltip"
                    mat-raised-button>
                    <i class="bi bi-info-circle"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <mat-dialog-actions align="end">
    <button class="secondary-btn me-2 text-center" mat-dialog-close="" type="button">
      {{ 'global.close' | translate }}
    </button>
    <button
      class="primary-btn me-2 text-center"
      [disabled]="shipmentMappingForm.pristine"
      (click)="saveShipmentConfigMapping()">
      {{ 'global.save' | translate }}
    </button>
  </mat-dialog-actions>
</div>
